import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { toast } from "sonner";
import { LibraryBig, ArrowRight, GraduationCap, Wrench, Sparkles } from "lucide-react";

const ICONS = { "Training-Led": GraduationCap, "Non-Training": Wrench, General: Sparkles };

export default function TemplatesPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    api.get("/templates").then((r) => setTemplates(r.data));
  }, []);

  const applyTemplate = async (t) => {
    try {
      const res = await api.post("/projects", { name: `${t.name} (Project)`, description: t.description, template_id: t.id });
      toast.success("Project created from template");
      navigate(`/projects/${res.data.id}`);
    } catch (e) {
      toast.error("Failed to create from template");
    }
  };

  return (
    <Layout>
      <header className="h-16 flex items-center px-6 border-b border-slate-200 bg-white/70 backdrop-blur-xl z-20 sticky top-0">
        <h1 className="font-display text-xl font-bold text-slate-900">Framework Templates</h1>
      </header>

      <div className="flex-1 overflow-y-auto p-6">
        <p className="text-slate-600 mb-6 max-w-2xl">
          Pre-configured ATD HPI starting points. Each template pre-seeds the Cause Analysis so the right intervention
          path (ADDIE training engine vs. non-training solutions) is ready to go.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {templates.map((t) => {
            const Icon = ICONS[t.category] || LibraryBig;
            return (
              <div key={t.id} data-testid={`template-card-${t.id}`} className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-all flex flex-col">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-md bg-emerald-100 flex items-center justify-center">
                    <Icon className="h-5 w-5 text-emerald-600" />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.15em] font-semibold text-slate-400">{t.category}</span>
                </div>
                <h3 className="font-display text-lg font-semibold text-slate-900 mt-4">{t.name}</h3>
                <p className="text-sm text-slate-500 mt-1 flex-1">{t.description}</p>
                <button
                  data-testid={`use-template-${t.id}`}
                  onClick={() => applyTemplate(t)}
                  className="mt-5 self-start bg-slate-900 text-white hover:bg-slate-800 px-4 py-2 rounded-md font-medium text-sm flex items-center gap-2 transition-colors"
                >
                  Use template <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
